// extracted by mini-css-extract-plugin
module.exports =  {"container":"N7su7E5","hover":"MONFRKJ","icon":"SuzJkCV","content":"ack4BB5"};